import React from "react";
import GridPage from "./pages/GridPage"; // ajusta si está en otro lugar

/** Hola-Admin.jsx (raíz)
 * Wrapper silencioso: NO hace useEffect, NO checa login, NO usa alert.
 * La seguridad la maneja ProtectedRoute.
 */
export default function HolaAdmin() {
  return <GridPage />;
}
